import { TabType } from "../../types";
import homeYard from "../../../../appAssets/homeTemplate/navIcons/homeYard.png";
import livingRoom from "../../../../appAssets/homeTemplate/navIcons/livingRoom.png";
import artAndDoodle from "../../../../appAssets/homeTemplate/navIcons/artAndDoodle.png";
import calmCornerIcon from "../../../../appAssets/homeTemplate/navIcons/calmCorner.png";
import "./RoomTabBar.scss";

interface RoomTabBarProps {
  activeTab: TabType;
  onTabPress: (tab: TabType) => void;
}

const TABS = [
  { type: TabType.Outdoor, label: "Outdoor", icon: homeYard },
  { type: TabType.Indoor, label: "Home", icon: livingRoom },
  { type: TabType.Explore, label: "Playroom", icon: artAndDoodle },
  { type: TabType.Character, label: "Calmroom", icon: calmCornerIcon },
];

function RoomTabBar({ activeTab, onTabPress }: RoomTabBarProps) {
  return (
    <div className="room-tab-bar">
      <div className="room-tab-bar__pill">
        {TABS.map(({ type, label, icon }) => (
          <button
            key={type}
            className="room-tab-bar__tab"
            onClick={() => onTabPress(type)}
            aria-label={label}
          >
            <div
              className={`room-tab-bar__icon-wrap${activeTab === type ? " room-tab-bar__icon-wrap--active" : ""}`}
            >
              <img src={icon} alt={label} className="room-tab-bar__icon-img" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default RoomTabBar;
